import { render, staticRenderFns } from "./InteligenceArtificial.vue?vue&type=template&id=76c2bcf5&scoped=true&"
import script from "./InteligenceArtificial.vue?vue&type=script&lang=js&"
export * from "./InteligenceArtificial.vue?vue&type=script&lang=js&"
import style0 from "./InteligenceArtificial.vue?vue&type=style&index=0&id=76c2bcf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c2bcf5",
  null
  
)

export default component.exports